import type { ColorToken } from '../../types';
import type { BorderRadiusToken } from './types';

export const SPACING_MAP: Record<string | number, number | undefined> = {
  '0': 0,
  '1': 1,
  '2': 2,
  '3': 3,
  '3-half': 3.5,
  '4': 4,
  '5': 5,
};

export const ALIGN_Y_MAP: Record<
  'top' | 'center' | 'bottom',
  'flex-start' | 'center' | 'flex-end'
> = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end',
};

export const BORDER_RADIUS_MAP: Record<BorderRadiusToken, string> = {
  0: '0',
  1: '0.125rem',
  2: '0.25rem',
} as const;

export const COLORS_MAP: Record<ColorToken, string> = {
  // safari handles 'transparent' strangely, so we define it using rgba instead
  transparent: 'rgba(255,255,255,0)',

  // Brand Colors
  green: 'greens.main',
  'green-light': 'primary.light',
  'green-lighter': '#81D6B8',
  'green-lighter-2': 'greens.lighter',
  'green-lightest': 'greens.lightest',
  'green-extra-light': 'greens.extraLight',
  'green-dark': 'greens.dark',
  'green-darkest': 'greens.darkest',
  'nw-green': '#8ccb32',
  'nw-logo-green': '#00AE4D',
  'nw-logo-green-dark': '#00682C',
  'nw-logo-green-light': '#8DC63F',

  blue: 'blues.main',
  'blue-light': '#4B99E6',
  'blue-lighter': 'blues.lighter',
  'blue-lighter-2': '#C8E4FE',
  'blue-lightest': 'blues.lightest',
  'blue-extra-light': 'blues.extraLight',
  'blue-dark': 'blues.dark',
  'blue-darkest': '#02143A',

  red: 'reds.main',
  'red-light': 'reds.light',
  'red-lighter': 'reds.lighter',
  'red-lighter-2': '#FFBFBF',
  'red-lightest': 'reds.lightest',
  'red-extra-light': '#FFF7F7',
  'red-dark': 'reds.dark',
  'red-darker': '#7A0000',

  yellow: 'yellows.main',
  'yellow-light': 'yellows.light',
  'yellow-lighter': 'yellows.lighter',
  'yellow-lighter-2': 'yellows.lighter-2',
  'yellow-lightest': 'yellows.lightest',
  'yellow-extra-light': '#FFFBF4',
  'yellow-dark': 'yellows.dark',
  'yellow-darkest': '#B07000',

  white: 'common.white',
  'neutral-darkest': 'common.black',
  'neutral-darker-2': 'neutral.darker',
  'neutral-darker': 'neutral.dark',
  'neutral-dark': 'neutral.main',
  'neutral-extra-dark': 'neutral.darker',
  'neutral-light': 'neutral.light',
  'neutral-lighter': 'neutral.lighter',
  'neutral-lighter-2': '#EBEBEC',
  'neutral-lightest': '#F7F7F7',

  bone: '#F4EEE6',

  brown: '#B96C4F',
  'brown-light': '#D58B70',
  'brown-lighter': '#EDBEAD',
  'brown-lighter-2': '#FFEAE2',
  'brown-lighter-3': '#FEF4F1',
  'brown-lighter-4': '#FFFAF9',
  'brown-lightest': '#FEF4F1',
  'brown-extra-light': '#FFFAF9',
  'brown-dark': '#91472B',
  'brown-darkest': '#652812',

  teal: 'blues.main',
  'teal-light': 'blues.lightest',
} as const;
